import { createSlice } from "@reduxjs/toolkit";
import { get_todo_order, get_todo_thunk } from "./todoThunk";

const initialState = {
  error: null,
  loading: false,
  descriptions: [],
  // redoStack: [],
  undoStack: [],
  copiedDescriptions: [],
  todoOrderIds: [],
};

// Helper function to save todos to localStorage

const saveTodosToLocalStorage = (todos) => {
  localStorage.setItem(`todos`, JSON.stringify(todos));
};

// Helper function to load todos from localStorageconst
const loadTodosFromLocalStorage = () => {
  const todos = localStorage.getItem("todos");
  // Check if todos is null or an empty string
  if (!todos || todos === "undefined") {
    return [];
  }
  try {
    return JSON.parse(todos);
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return [];
  }
};
// thunk
const getTodosCases = (builder) => {
  builder
    .addCase(get_todo_thunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(get_todo_thunk.fulfilled, (state, action) => {
      state.descriptions = action.payload.data.response;
      state.loading = false;
    })
    .addCase(get_todo_thunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Login Cases Error";
    });
};

const getTodoOrderIdCases = (builder) => {
  builder
    .addCase(get_todo_order.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(get_todo_order.fulfilled, (state, action) => {
      state.todoOrderIds = action.payload;
      state.loading = false;
    })
    .addCase(get_todo_order.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Redux Cases Error";
    });
};

const descriptionSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {
    addDescription: (state, action) => {
      state.descriptions.unshift(action.payload.description);
      saveTodosToLocalStorage(state.descriptions);
    },
    getTodosFromLocalStorage: (state, action) => {
      state.descriptions = loadTodosFromLocalStorage();
    },
    deleteDescription: (state, action) => {
      const { descIds } = action.payload; // Destructure array of description IDs

      // Filter out descriptions that are not in the `descIds` array
      state.descriptions = state.descriptions.filter(
        (desc) => !descIds.includes(desc.id) // Exclude descriptions with matching IDs
      );

      saveTodosToLocalStorage(state.descriptions);
    },
    editDescription: (state, action) => {
      const { descId, text } = action.payload;
      const description = state.descriptions.find((desc) => desc.id === descId);
      if (description) {
        description.text = text;
      }

      saveTodosToLocalStorage(state.descriptions);
    },
    toggleDescriptionCompletion: (state, action) => {
      const { descId } = action.payload;
      const description = state.descriptions.find((desc) => desc.id === descId);
      if (description) {
        description.completed = !description.completed;
      }
      saveTodosToLocalStorage(state.descriptions);
    },
    undoDescription: (state) => {
      if (state.undoStack.length > 0) {
        const lastDeleted = state.undoStack[state.undoStack.length - 1];
        state.undoStack = state.undoStack.slice(0, -1); // Remove last undo action
        // state.redoStack.push([...lastDeleted]); // Push to redo stack
        lastDeleted.forEach((deletedItem) => {
          const index = state.descriptions.findIndex(
            (desc) => desc.id === deletedItem.id
          );
          if (index === -1) {
            state.descriptions.push(deletedItem); // Add back the deleted item
            saveTodosToLocalStorage(state.descriptions);
          }
        });
      }
    },
    // redoDescription: (state) => {
    //     if (state.redoStack.length > 0) {
    //         const lastRestored = state.redoStack[state.redoStack.length - 1]; // Get the last restored state
    //         console.log('Redoing deletion:', lastRestored);

    //         state.redoStack = state.redoStack.slice(0, -1); // Remove the last redo entry
    //         state.undoStack.push([...lastRestored]); // Save to undo stack

    //         // Remove restored items from descriptions
    //         state.descriptions = state.descriptions.filter(
    //             (desc) => !lastRestored.some((restored) => restored.id === desc.id)
    //         );
    //     }
    // },

    saveStateForUndoRedux: (state, action) => {
      const { deletedItems } = action.payload;
      state.undoStack.push([...deletedItems]); // Save only affected items
      // state.redoStack = [];
    },
    updateTodoPriority: (state, action) => {
      if (!Array.isArray(action.payload)) {
        return;
      }

      // Create a priority map for O(1) lookup
      const priorityMap = action.payload.reduce((map, update) => {
        const key = `${update.fileId}-${update.id}`;
        map[key] = update.priority;
        return map;
      }, {});

      let data = state.descriptions.map((todo) => {
        const key = `${todo.fileId}-${todo.id}`;
        const newPriority = priorityMap[key];

        if (newPriority !== undefined) {
          return {
            ...todo,
            priority: newPriority,
          };
        }
        return todo;
      });

      saveTodosToLocalStorage(data);
    },
    copyDescription: (state, action) => {
      state.copiedDescriptions = action.payload.descriptions;
    },
    pasteDescription: (state, action) => {
      if (state.copiedDescriptions.length > 0) {
        const newDescriptions = state.copiedDescriptions.map((desc) => ({
          ...desc,
          id: action.payload.newIds[desc.id],
          fileId: action.payload.fileId,
        }));
        newDescriptions.forEach((desc) => {
          delete desc.priority;
          state.descriptions.unshift(desc);
        });
        saveTodosToLocalStorage(state.descriptions);
      }
    },
    setTodoOrderIds: (state, action) => {
      const { fileId, todoIds } = action.payload;
      state.todoOrderIds = {
        ...state.todoOrderIds,
        [fileId]: todoIds,
      };
    },
    clearFiles: (state) => {
      state.files = [];
    },
    clearTodos: (state) => {
      state.descriptions = [];
      state.undoStack = [];
      state.copiedDescriptions = [];
    },
  },
  extraReducers: (builder) => {
    getTodosCases(builder);
    getTodoOrderIdCases(builder);
  },
});

// Export actions for use in components
export const {
  addDescription,
  getTodosFromLocalStorage,
  deleteDescription,
  editDescription,
  toggleDescriptionCompletion,
  undoDescription,
  // redoDescription,
  saveStateForUndoRedux,
  updateTodoPriority,
  clearTodos,
  copyDescription,
  pasteDescription,
  setTodoOrderIds,
  clearFiles,
} = descriptionSlice.actions;

// Export the reducer to be used in the store
export default descriptionSlice.reducer;
